import request from '@/utils/request'

/**
 * 客服类型列表
 * POST /api/v1/admin/site_management/customer_service/type/list
 */
export function getCustomerServiceTypeList(data) {
  return request({
    url: '/api/v1/admin/site_management/customer_service/type/list',
    method: 'post',
    mock: false,
    data: data || {},
  })
}

/**
 * 新增客服类型
 * POST /api/v1/admin/site_management/customer_service/type/add
 */
export function addCustomerServiceType(data) {
  return request({
    url: '/api/v1/admin/site_management/customer_service/type/add',
    method: 'post',
    mock: false,
    data,
  })
}

/**
 * 更新客服类型
 * POST /api/v1/admin/site_management/customer_service/type/update
 */
export function updateCustomerServiceType(data) {
  return request({
    url: '/api/v1/admin/site_management/customer_service/type/update',
    method: 'post',
    mock: false,
    data,
  })
}

/**
 * 删除客服类型
 * POST /api/v1/admin/site_management/customer_service/type/delete
 */
export function deleteCustomerServiceType(id) {
  return request({
    url: '/api/v1/admin/site_management/customer_service/type/delete',
    method: 'post',
    mock: false,
    data: { id },
  })
}

/**
 * 客服列表
 * POST /api/v1/admin/site_management/customer_service/list
 */
export function getCustomerServiceList(data) {
  return request({
    url: '/api/v1/admin/site_management/customer_service/list',
    method: 'post',
    mock: false,
    data,
  })
}

/**
 * 新增客服
 * POST /api/v1/admin/site_management/customer_service/add
 */
export function addCustomerService(data) {
  return request({
    url: '/api/v1/admin/site_management/customer_service/add',
    method: 'post',
    mock: false,
    data,
  })
}

/**
 * 更新客服
 * POST /api/v1/admin/site_management/customer_service/update
 */
export function updateCustomerService(data) {
  return request({
    url: '/api/v1/admin/site_management/customer_service/update',
    method: 'post',
    mock: false,
    data,
  })
}

/**
 * 删除客服
 * POST /api/v1/admin/site_management/customer_service/delete
 */
export function deleteCustomerService(id) {
  return request({
    url: '/api/v1/admin/site_management/customer_service/delete',
    method: 'post',
    mock: false,
    data: { id },
  })
}

/**
 * 7*24小时客服 - 获取配置
 * GET /api/v1/admin/site_management/customer_service_24/get
 * 返回: { config_url }
 */
export function getCustomerService24() {
  return request({
    url: '/api/v1/admin/site_management/customer_service_24/get',
    method: 'post',
    mock: false,
  })
}

/**
 * 7*24小时客服 - 保存配置
 * POST /api/v1/admin/site_management/customer_service_24/save
 * 请求体: { config_url }
 */
export function saveCustomerService24(data) {
  return request({
    url: '/api/v1/admin/site_management/customer_service_24/save',
    method: 'post',
    mock: false,
    data,
  })
}
